module.exports = __webpack_public_path__ + "img/02028976400015.76bd61f5.png";